export const ALL_PROBLEM_FILTERS = ['BFS', 'Binary Search'];
